import React, { useContext, Fragment } from 'react'
import { RootStoreContext } from '../../../model/root-store'
import { List, Icon } from 'semantic-ui-react'
import { isAfter } from 'date-fns'
import { ModalEditCustomer } from '../../../components/ModalEditCustomer'
import { LabelCustomerCardStatus } from '../../../components/LabelCustomerCardStatus'
import { FormattedDate } from 'react-intl'
import { observer } from 'mobx-react-lite'

export const CurrentOrderCustomer = observer(function CurrentOrderCustomer() {
  const rootStore = useContext(RootStoreContext)
  const orderStore = rootStore.orderStore

  function handleClearCustomer() {
    orderStore.clearCustomer()
  }

  return orderStore.computedCustomer ? (
    <Fragment>
      <List>
        <List.Item>
          <List.Content floated="right">
            <Icon name="remove" link onClick={handleClearCustomer} />
          </List.Content>
          <List.Content>
            <List.Header>KH: {orderStore.computedCustomer.fullName}</List.Header>
            <List.Description>
              {orderStore.computedCustomer.cellphone}
              {orderStore.computedCustomer.isStaff && ' (Nhân viên 4handy)'}
            </List.Description>
          </List.Content>
        </List.Item>

        <List.Item>
          <List.Content>
            <List.Header>
              Trạng thái thẻ:
              <ModalEditCustomer customer={orderStore.customer}>
                <LabelCustomerCardStatus customerCardStage={orderStore.customerCardStage} />
              </ModalEditCustomer>
            </List.Header>
            {orderStore.isPendingCustomerCard && orderStore.computedCustomer.registerTime && (
              <List.Description>
                Ngày đăng ký thẻ: <FormattedDate value={orderStore.computedCustomer.registerTime} />
                .
              </List.Description>
            )}
            {orderStore.computedCustomer.numRemainDiscount &&
            !orderStore.computedCustomer.remainDiscountValue ? (
              <List.Description>
                Số cốc nước giảm giá còn lại được mua :{' '}
                {orderStore.computedCustomer.numRemainDiscount}
              </List.Description>
            ) : null}
            {orderStore.computedCustomer.remainDiscountValue ? (
              <List.Description>
                Tổng giá trị còn được giảm giá : {orderStore.computedCustomer.remainDiscountValue}
              </List.Description>
            ) : null}
            {orderStore.computedCustomer.numSaleBread ? (
              <List.Description>
                Số đơn đã mua được giảm giá NV hôm nay : {orderStore.computedCustomer.numSaleBread}
              </List.Description>
            ) : null}
            {(() => {
              const numGifted = orderStore.computedCustomer.numGiftedNationalDayCake || 0
              const now = new Date()
              const endTime = new Date('2025-09-04T00:00:00+07:00')
              const isInGiftPeriod = now < endTime

              // Chỉ hiển thị trong thời gian chương trình
              if (!isInGiftPeriod) return null

              return (
                <List.Description
                  style={{
                    color: numGifted >= 3 ? '#cf1322' : '#d4380d',
                    fontWeight: 'bold',
                    backgroundColor: numGifted >= 3 ? '#fff1f0' : 'transparent',
                    padding: numGifted >= 3 ? '2px 4px' : '0',
                    borderRadius: '2px'
                  }}
                >
                  Số đơn đã tặng bánh yêu nước 2/9: {numGifted}/3
                  {numGifted >= 3 && ' (Đã hết lượt)'}
                </List.Description>
              )
            })()}
            {(() => {
              const customer = orderStore.computedCustomer
              const giftResult = customer.scakePremiumCutleryGiftResult
              const now = new Date()
              const startTime = new Date('2025-09-03T00:00:00+07:00')
              if (now < startTime) return null

              // Nếu không có thông tin từ backend
              if (!giftResult) return null

              const month1Count = giftResult.ordersInPreviousMonth || 0
              const month2Count = giftResult.ordersInTwoMonthsAgo || 0
              const isEligible = giftResult.isEligible || false

              return (
                <Fragment>
                  <List.Description
                    style={{
                      marginTop: '8px',
                      padding: '8px',
                      backgroundColor: isEligible ? '#f6ffed' : '#fff7e6',
                      border: `1px solid ${isEligible ? '#b7eb8f' : '#ffd591'}`,
                      borderRadius: '4px'
                    }}
                  >
                    <div
                      style={{
                        marginBottom: '4px',
                        color: isEligible ? '#52c41a' : '#fa8c16'
                      }}
                    >
                      <Icon name={isEligible ? 'gift' : 'info circle'} />
                      Tặng Bộ dao dĩa cao cấp V10089:{' '}
                      {isEligible ? (
                        <span
                          style={{
                            fontSize: '12px',
                            color: '#ff4d4f',
                            fontWeight: 'bold'
                          }}
                        >
                          ✓ Đủ điều kiện nếu đơn hiện tại từ 200k
                        </span>
                      ) : null}
                    </div>
                    <div style={{ fontSize: '12px', color: '#595959' }}>
                      • {giftResult.month2Period}: {month2Count} đơn
                    </div>
                    <div style={{ fontSize: '12px', color: '#595959' }}>
                      • {giftResult.month1Period}: {month1Count} đơn
                    </div>
                  </List.Description>
                </Fragment>
              )
            })()}
            {(() => {
              const customer = orderStore.computedCustomer
              const mooncakeResult = customer.mooncakeDiscountWithBirthdayCakeResult
              if (isAfter(new Date(), new Date('2025-10-20T00:00:00+07:00'))) return null

              // Nếu không có thông tin từ backend
              if (!mooncakeResult) return null

              const totalDiscountToday = 200000
              const remainingDiscountToday = mooncakeResult.remainingDiscountToday || 0
              const usedDiscountToday = totalDiscountToday - remainingDiscountToday
              const isEligible = remainingDiscountToday > 0

              // Format số tiền
              const formatMoney = (amount: number) => {
                return new Intl.NumberFormat('vi-VN').format(amount) + 'đ'
              }

              return (
                <Fragment>
                  <List.Description
                    style={{
                      marginTop: '8px',
                      padding: '8px',
                      backgroundColor: isEligible ? '#f0f5ff' : '#fff7e6',
                      border: `1px solid ${isEligible ? '#91d5ff' : '#ffd591'}`,
                      borderRadius: '4px'
                    }}
                  >
                    <div
                      style={{
                        marginBottom: '4px',
                        color: isEligible ? '#1890ff' : '#fa8c16'
                      }}
                    >
                      <Icon name={isEligible ? 'percent' : 'info circle'} />
                      Giảm 50% Bánh Trung Thu khi mua Bánh Sinh Nhật:{' '}
                      {isEligible ? null : (
                        <span
                          style={{
                            fontSize: '12px',
                            color: '#ff4d4f',
                            fontWeight: 'bold'
                          }}
                        >
                          ✗ Đã hết lượt giảm giá hôm nay
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: '12px', color: '#595959' }}>
                      • Tổng giảm giá mỗi ngày: {formatMoney(totalDiscountToday)}
                    </div>
                    <div style={{ fontSize: '12px', color: '#595959' }}>
                      • Đã sử dụng: {formatMoney(usedDiscountToday)}
                    </div>
                    <div style={{ fontSize: '12px', color: isEligible ? '#52c41a' : '#595959' }}>
                      • Còn lại: {formatMoney(remainingDiscountToday)}
                    </div>
                  </List.Description>
                </Fragment>
              )
            })()}
          </List.Content>
        </List.Item>
      </List>
    </Fragment>
  ) : null
})
